import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import {
  OrderData,
  useOrder,
  useCheckoutOrder,
} from '../../../services/api/orders'
import { AsyncStates } from '../../../components'
import { View } from './View'
import { notification } from 'antd'
import { Moment } from 'moment-timezone'
import { toMoment } from '../../../utils/formatter'

const REFUND_STATUS = 'refunded'
const CHECKOUT_STATUS = 'failed'

export const Container: React.FunctionComponent = () => {
  const { id } = useParams()
  const [getOrder, { isLoading, response, error }] = useOrder(id)
  const [isRefundVisible, setIsRefundVisible] = useState<boolean>(false)
  const [checkoutOrder] = useCheckoutOrder(id)

  useEffect(() => {
    getOrder()
  }, [getOrder])

  const onCheckout = () => {
    return checkoutOrder()
      .then(() => {
        getOrder()
        notification.success({
          message: 'Возврат успешно оформлен',
          duration: 3,
        })
      })
      .catch(() => {
        notification.error({
          message:
            'Возникли ошибки при оформлении возврата. Попробуйте еще раз позже или обратитесь в службу поддержки',
          duration: 3,
        })
      })
  }

  return (
    <AsyncStates<OrderData>
      isLoading={isLoading}
      error={error}
      errorMessage="Не удалось загрузить заказ"
      reload={() => getOrder()}
      response={response}
      renderData={(order) => {
        const departureTime: Moment = toMoment(
          order.flight.parts[0].segments[0].departureTime
        )
        const refundAllowed: boolean =
          (order.status === 'completed' && departureTime.isAfter()) ||
          order.status === 'failed'
        const refunded: boolean = order.status === REFUND_STATUS
        const checkoutAllowed: boolean =
          order.status === CHECKOUT_STATUS && departureTime.isAfter()

        return (
          <View
            order={order}
            refunded={refunded}
            refundAllowed={refundAllowed}
            isRefundVisible={isRefundVisible}
            setIsRefundVisible={setIsRefundVisible}
            onRefund={() => getOrder()}
            checkoutAllowed={checkoutAllowed}
            checkoutOrder={onCheckout}
          />
        )
      }}
    />
  )
}
